import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SponsorService {

  url: string = environment.api.endpoint;

  constructor(private http: HttpClient) { }

  create(form: any){
    return this.http.post(`${this.url}/sponsor`, form);
  }

  update(id: string, form: any){
    return this.http.put(`${this.url}/sponsor/update/${id}`, form)
  }

  delete(id: string, model: any){
    return this.http.post(`${this.url}/sponsor/delete/${id}`, model);
  }

  getById(id: string): any{
    return this.http.get(`${this.url}/sponsor/${id}`);
  }

  getAllByIteration(filter: any): any {
    return this.http.get(`${this.url}/sponsors/byoutingiteration/${filter.outingIterationId}`, { params: filter });
  }

}
